import { Component } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { LoansService } from "app/modules/loan/loans/loans.service";
import { ToastrService } from "ngx-toastr";
import { FileViewerComponent } from "../file-viewer/file-viewer.component";
import { ConfirmDialogComponent } from "app/shared/confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'approved-loan-document',
  templateUrl: './approved-loan-document.component.html',
  styleUrls: ['./approved-loan-document.component.scss']
})
export class ApprovedLoanDocumentComponent {
  documentType: string;
  files: File[] = [];
  dataSource = [];
  userType = 'Loan';
  displayedColumns: string[] = ['loanNumber', 'documentName', 'uploadUser', 'download'];
  maxSizeInMB = 10;
  acceptedFileTypes = '.pdf,.jpg,.jpeg,.png,.doc,.docx,application/pdf,image/jpeg,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  private readonly allowedDocumentMessage = 'Only PDF, JPG, JPEG, PNG, DOC and DOCX files are allowed.';
  private readonly allowedMimeTypes = [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/zip',
    'application/x-zip-compressed',
    'application/octet-stream'
  ];
  private readonly allowedExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx'];
  private readonly macroExtensions = ['docm', 'dotm'];
  uploadSectionLoanAgreement = false;
  uploadSectionLoanOrignationFee = false;
  uploadSectionApprovalLetter = false;
  uploadSectionCosignerLetter = false;
  uploadSectionLoanAch = false;

  constructor(private _toastrService: ToastrService,
    private route: ActivatedRoute,
    private _loanService: LoansService,
    public dialog: MatDialog
  ) { }

  clearFile(documentType) {
    if (this.documentType != documentType) {
      this.documentType = documentType;
      this.files = [];
      this.dataSource = [];
    }
    this.getUploadedDocument(documentType);
  }

  onSelect(event) {

    if (event.rejectedFiles?.length) {
      const rejectedName = event.rejectedFiles[0]?.name || '';
      const rejectedExt = (rejectedName.split('.').pop() || '').toLowerCase();
      this._toastrService.error(
        this.macroExtensions.includes(rejectedExt)
          ? 'Word documents with macros are not allowed.'
          : this.allowedDocumentMessage
      );
      return;
    }

    const addedFile = event.addedFiles?.[0];
    if (!addedFile) {
      return;
    }

    const maxSizeBytes = this.maxSizeInMB * 1024 * 1024;
    if (addedFile.size > maxSizeBytes) {
      this._toastrService.error("File size allow 10MB only");
      return;
    }

    const extension = (addedFile.name.split('.').pop() || '').toLowerCase();
    if (this.macroExtensions.includes(extension)) {
      this._toastrService.error('Word documents with macros are not allowed.');
      return;
    }
    const mimeOk = !addedFile.type || this.allowedMimeTypes.includes(addedFile.type);
    if (!mimeOk || !this.allowedExtensions.includes(extension)) {
      this._toastrService.error(this.allowedDocumentMessage);
      return;
    }

    let file = this.files.filter(x => x.name == addedFile.name);
    if (file.length == 0) {
      this.files.push(...event.addedFiles);
    }
    else {
      this._toastrService.error("Duplicate file not allowed.");
      return;
    }
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  UploadDocument(documentType) {

    let loanNumber = this.route.snapshot.paramMap.get('loanNumber');
    this.files.forEach(x => {
      const formData = new FormData();
      formData.append("formFile", x);
      this._loanService.apiPostDocument(formData, loanNumber, documentType, this.userType)
        .subscribe((response) => {
          this.getUploadedDocument(documentType);
          this._toastrService.success(response.data.message);
          this.showFileUploadSection('');
        },
          (error) => {
            this._toastrService.error(error?.error?.failureMessage || "Error uploading document");
          });
    });
    this.getUploadedDocument(documentType);
  }

  getUploadedDocument(documentType) {
    this.dataSource = [];
    let loanNumber = this.route.snapshot.paramMap.get('loanNumber');
    this._loanService.apiGetDocument(loanNumber, this.userType)
      .subscribe((response) => {
        if (response && response.data && response.data.documentList && response.data.documentList.length > 0) {
          response.data.documentList.forEach(element => {
            if (element.documentType == documentType) {
              this.dataSource.push(element);
            }
          });
        }
      },
        (error) => {
          console.log(error);
        })
  }

  downloadDocument(element) {
    console.log(element);
    this._loanService.apiDownloadDocument(element.documentId)
      .subscribe((response) => {
        console.log(response);
        const filename = element.documentName;
        
        var a = document.createElement('a');
        a.setAttribute('href', response.data.file);
        document.body.appendChild(a);
        a.setAttribute('download', filename);
        
        a.click();
      },
        (error) => {
          console.log(error);
        })
  }

 previewDocument(element) {
  this._loanService.apiPreviewDocument(element.documentId).subscribe(
    (response) => {
      this.openDialog(response.data.file, response.data.fileName || element.documentName);
    },
    (error) => {
      console.log(error);
    }
  );
}


  dialogRef: MatDialogRef<FileViewerComponent>;
    openDialog(fileUrl, documentName) {
  this.dialogRef = this.dialog.open(FileViewerComponent, {
    width: '70%',
    height: '100%',
    data: { file: fileUrl, fileName: documentName } 
  });
}

onDeleteFile(element: any, documentType: string) {
    console.log('Delete document:', element);
  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    width: '350px',
    data: {
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this document with Name: ' + '"'+element.documentName+'"' + '?',
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      // Usuario confirmó → ejecutar eliminación
      this._loanService.apiPostDocumentDelete(element.documentId).subscribe(
        (response) => {
          if (response) {
            this._toastrService.success("Document deleted successfully");
            this.getUploadedDocument(documentType);
          }
        },
        (error) => {
          this._toastrService.error(error.error.failureMessage);
        }
      );
    } else {
      // Usuario canceló → no hacer nada
      this._toastrService.info("Deletion cancelled");
    }
  });
}


  showFileUploadSection(documentType) {
    this.uploadSectionLoanAgreement = false;
    this.uploadSectionLoanOrignationFee = false;
    this.uploadSectionApprovalLetter = false;
    this.uploadSectionCosignerLetter = false;
    this.uploadSectionLoanAch = false;

    if (documentType === 'LoanAgreement') {
      this.files = [];
      this.uploadSectionLoanAgreement = true;
    }
    else if (documentType === 'LoanOrignationFee'){
        this.files = [];
        this.uploadSectionLoanOrignationFee = true;
    }
    else if (documentType === 'ApprovalLetter'){
        this.files = [];
        this.uploadSectionApprovalLetter = true;
    }
    else if(documentType === 'CosignerLetter'){
        this.files = [];
        this.uploadSectionCosignerLetter = true;
    }
    else if (documentType === 'LoanAch'){
        this.files = [];
        this.uploadSectionLoanAch = true;
    }
  }

}